var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"kd-tab-item",class:[_vm.activeClassName, _vm.typeClassName],attrs:{"id":`kd_tab_item_${_vm.name}`}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.type === 'text-instruc' && _vm.active)?_c('div',{staticClass:"instruction"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }